import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "as", "children"];
import React from 'react';
import Icon from 'components/Icon';
import Text from 'components/Text';
import Tab from '.';
var NavBarTab = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    as = _ref.as,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/React.createElement(Tab, _extends({
    stackBelow: "m"
  }, otherProps, {
    as: Component,
    ref: ref
  }), icon && /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    size: "medium"
  }), /*#__PURE__*/React.createElement(Text, {
    align: "center",
    mx: [null, 'xxs'],
    ml: icon ? [null, null, 'xs'] : undefined,
    size: ['xxs', 's', 'm'],
    breakpoints: ['xxs', 'm']
  }, children));
});
NavBarTab.displayName = 'NavBarTab';
export default NavBarTab;